import { useState, useContext } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import _get from 'lodash/get';
import { AppContext } from 'commons-ui';
import useService from '../../utils/useService';
import { hydrateFormData, dehydrateFormData } from '../../utils/formDataParser';
import { ICustomResponse, IGSTConfig, ISegmentConfigData } from '../../utils/type';

const useEdit = () => {
	const [showLoader, setShowLoader] = useState(false);
	const { app, showAlert } = useContext(AppContext);
	const history = useHistory();
	const location = useLocation();
	const { requestUpdateConfig } = useService();

	const updateConfig = (gstConfig: IGSTConfig) => {
		setShowLoader(true);
		requestUpdateConfig(app.appName, { ...gstConfig }).then(
			(res: ICustomResponse) => {
				if (res?.status !== 200 || !res?.data?.success) {
					showAlert(res?.data?.error || 'Error occured while updating the GST config', { type: 'error' });
					setShowLoader(false);
				} else {
					showAlert('Config Updated');
					history.goBack();
				}
			},
			(err: any) => {
				showAlert(`Error: ${err?.response?.data?.error}`, { type: 'error' });
				setShowLoader(false);
			}
		);
	};

	const handleFormSubmit = (submittedData: ISegmentConfigData) => {
		updateConfig(dehydrateFormData(submittedData));
	};

	const handleFormCancel = () => {
		history.goBack();
	};
	return {
		data: hydrateFormData(_get(location, ['state', 'rowData'])),
		showLoader,
		handleFormSubmit,
		handleFormCancel,
		setShowLoader
	};
};

export default useEdit;
